import Api from '@common/services/api';
import { APIEvaluationForm } from '../types';

export const fetchPerformanceForm = async (
    organisationId: string,
    id: string
  ) => {
    return Api.get<{ data: APIEvaluationForm }>(
      `/v1/organisations/${organisationId}/performance/forms/${id}`
    );
  };
